export {
  Cportal,
  PORTAL_ROOT_CONTAINER_ID,
  PORTAL_ROOT_Z_INDEX,
} from './Cportal';
export type { CportalProps } from './Cportal';

